import { render, staticRenderFns } from "./contact-form.vue?vue&type=template&id=04058637&scoped=true"
import script from "./contact-form.vue?vue&type=script&lang=js"
export * from "./contact-form.vue?vue&type=script&lang=js"
import style0 from "./contact-form.vue?vue&type=style&index=0&id=04058637&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04058637",
  null
  
)

export default component.exports